export default {"src":"/_next/static/media/google-meet.58b40b81.svg","height":297,"width":256};